<template>
	<div id="importAllPlan">
		<el-dialog  title="导入派工"  :visible.sync="isShowDialog" :width="W?'40%':'60%'" center :close-on-click-modal="false" @close="cancelAddDialog">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="16" :offset="4">
                        <span class="title" style="width:84px;margin-left:-14px">销售订单号：</span>
                        <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select :remote-method="remoteMethod" @visible-change="closeOrder" @change="orderSelect"  style="max-width:180px" filterable remote :loading="loading"  v-model='addForm.orderId' size='small' maxlength='16' placeholder='销售订单号' >
                                <el-option v-for="item in orderList" :key="item.orderId" :value="item.orderId" :label="item.orderCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="16" :offset="4">
                        <span class="title">物料编码：</span>
                        <el-form-item prop="materialId" :rules="rules.materialId" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select @change='materialSelect' :remote-method="query=>{this.remoteMethod1(query)}" remote :loading="loading" remoteMethod1 clearable style="max-width:180px" filterable v-model='addForm.materialId' size='small' maxlength='16' placeholder='物料编码' >
                                <el-option v-for="item in materialList" :key="item.materialId" :value="item.materialId" :label="item.materialCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="16" :offset="4">
                        <span class="title">物料名称：</span>
                        <el-form-item   class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                            <el-select @change='materialSelect' :remote-method="query=>{this.remoteMethod1('',query)}" remote :loading="loading" clearable style="max-width:180px" filterable v-model='addForm.materialId' size='small' maxlength='16' placeholder='物料名称' >
                                <el-option v-for="item in materialList" :key="item.materialId" :value="item.materialId" :label="item.materialName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-table  :data="splitItemData" stripe  @selection-change="handleSelectionChange" ref='splitTable'>
                <el-table-column type="selection" width="55" ></el-table-column>
                <el-table-column label="订单号" min-width="100" prop="orderCode" show-overflow-tooltip></el-table-column>
                <el-table-column label="工单号" min-width="100" prop="productionBatchCode" show-overflow-tooltip></el-table-column>
                <el-table-column label="物料名称" min-width="100" prop="materialName" show-overflow-tooltip></el-table-column>
                <el-table-column label="物料编码" prop="materialCode" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="规格" min-width="50" prop="specification" show-overflow-tooltip></el-table-column>
                <el-table-column label="数量" prop="splitCount" min-width="70"></el-table-column>
            </el-table>
			<div style="text-align: center;margin-top:20px">
                <el-button type="primary" @click="submitAddOrder">确 定</el-button>
                <el-button  @click="cancelAddDialog">取 消</el-button>
            </div>
		</el-dialog>
	</div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils';

export default {
	name: 'ImportAllPlan',
	props: {
        isShow: Boolean,
        orderRowMaterialName: String,
        orderCode:String,
	},
	data() {
		return {
            pickerOption:{
                disabledDate(time) {
                    return time.getTime() < Date.now()
                }
            },
            splitItemData:[],
            isShowDialog: false,
            addForm:{
                orderId:null,
                materialId:null,
            },
            rules:{
                materialId: [
                    {required: true, message: '请选择物料', trigger: 'blur'}
                ],
                
            },
            selectData:[],
            W:true,
            loading:false,
            materialList:[],
            orderList:[],
		}
	},
	//el和data尚未初始化
	beforeCreate: function(){},
	//data初始化完成
	created: function(){
		
	},
	//el初始化完成
	beforeMount: function(){},
	//完成挂载
	async mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
        
	},
	//更新dom时触发
	beforeUpdate: function(){},
	updated: function(){},
	beforeDestroy: function(){},
	destroyed: function(){},
	components: {},
	computed: {
	},
	methods: {
        handleSelectionChange(ev){
            this.selectData = ev
            log(this.selectData)
        },

        submitAddOrder(){
            if(this.selectData.length==0){
                this.$message.error('请选择需要导入派工的工单')
                return
            }
            this.$parent.matchingImportData(this.selectData)
            // this.$refs['addForm'].validate((valid) => {
            //     if (valid) {
            //         this.addForm.technologyId = this.technologyId
            //         this.$RequestUtil.get({
            //             url: '/api/productionTask/executionGroup',
            //             type: 'sync',
            //             params: this.addForm,
            //             success: (res) => {
            //                 if (res.code == 0) {
            //                     this.$message.success('查询成功')
            //                     this.cancelAddDialog()
            //                     this.$parent.getPlanByTecId(res.data);  
            //                 } else {
            //                     this.$message.error(res.message);
            //                 }
            //             },
            //         })
            //     }
            // })
        },

        async loadOrderList(orderCode){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listOrderProduction',type:'async',params: {orderCode}})
            if(code==0){ 
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        async remoteMethod(query){
            this.loading = true
            this.orderList = await this.loadOrderList(query)
            this.loading = false
        },

        async closeOrder(ev){
            if(!ev){
                this.orderList = await this.loadOrderList()
            }
        },

        async loadMaterialByOrderId(orderId,materialCode,materialName){
            
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/select/listMaterialByOrderId',type:'async',params: {orderId,materialCode,materialName}})
            if(code==0){ 
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        async remoteMethod1(materialCode,materialName){
            this.loading = true
            this.materialList = await this.loadMaterialByOrderId(this.addForm.orderId,materialCode,materialName)
            this.loading = false
        },

       

        async materialSelect(ev){
            if(!ev){
                return
            }
            log(this.orderRowMaterialName,666)
            let find = this.materialList.find(item=>item.materialId==ev)||{}
            
            if(find.materialName==this.orderRowMaterialName){
                this.splitItemData = await this.loadTaskListByMaterialId(this.addForm.orderId,ev)
                this.selectData = CommonUtils.cloneObj(this.splitItemData) 
                this.$refs['splitTable'].toggleAllSelection()
            }else{
               this.$set(this.addForm,'materialId',null)
                this.$message.error('物料名称不匹配，无法导入')
            }
            
        },

        async orderSelect(ev){
            this.$set(this.addForm,'materialId',null)
            
            this.splitItemData = []
            if(!ev){
                this.materialList = []
                return
            }
            this.materialList = await this.loadMaterialByOrderId(ev)
        },

        async loadTaskListByMaterialId(orderId,materialId){
            let {data,code,msg,message} = await this.$RequestUtil.postAsync({url: '/api/order/listImportDispatching',type:'async',params: {orderId,materialId}})
            if(code==0){ 
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

		cancelAddDialog() {
            this.addForm = {
                orderCode:'',
                orderId:null,
                materialId:null,
                itemList:[],
            }
            this.itemList = []
            this.$parent.isShowDialog = false
        },

	},
	watch: {
		"isShow": async function (newVal, oldVal) {
            if(this.isShow){
                this.$RequestUtil.loading()
                this.orderList = await this.loadOrderList(this.orderCode)
                this.$RequestUtil.loading().close()
                this.isShowDialog = this.isShow;
                if(this.orderCode){
                    let orderId = (this.orderList.find(item=>item.orderCode==this.orderCode)||{}).orderId
                    if(orderId){
                        this.$set(this.addForm,'orderId',orderId)
                        await this.orderSelect(orderId)
                    }
                }

            }
			this.isShowDialog = this.isShow;
        },
        
	},
}
</script>
<style scoped>
    .delete {
        width: 18px;
        height: 19px;
        background-image: url('/static/img/del.png');
        cursor: pointer;
        background-repeat: no-repeat;
    }

    .delete:hover {
        background-image: url('/static/img/del-hover.png');
        background-repeat: no-repeat;
    }
    .title {
            color: #606266;
            font-family: NotoSansHans-Regula;
            font-size: 14px;
            display: inline-block;
            text-align: right;
            width: 70px;
        }

        .value {
            display: inline-block
        }

    @media screen and (min-width: 1300px) and (max-width: 1930px){
    
    }
</style>


<style>
#importAllPlan .el-table-column--selection .cell {
    padding-left: 10px;
}

</style>


// WEBPACK FOOTER //
// src/views/order/SalesOrder/ImportAllPlan.vue